import React, { useCallback, useMemo } from 'react';
import { AuthProvider as OIDCContextProvider } from 'react-oidc-context';
import { User, WebStorageStateStore } from 'oidc-client-ts';
import { useNavigate } from 'react-router';
import env from '../utils/env';

function AuthProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  const navigate = useNavigate();

  const onSigninCallback = useCallback(
    (user: User | void): void => {
      navigate(user?.url_state || '/', { replace: true });
    },
    [navigate],
  );

  const userStore = useMemo(() => new WebStorageStateStore({ store: globalThis.localStorage }), []);

  if (!env.azureAd.tenantId || !env.azureAd.clientId) {
    throw new Error('Azure AD tenant ID and client ID must be set in environment variables');
  }

  const oidcConfig = {
    authority: `https://login.microsoftonline.com/${env.azureAd.tenantId}/v2.0`,
    metadata: {
      issuer: `https://login.microsoftonline.com/${env.azureAd.tenantId}/v2.0`,
      token_endpoint: `https://login.microsoftonline.com/${env.azureAd.tenantId}/oauth2/v2.0/token`,
      authorization_endpoint: `https://login.microsoftonline.com/${env.azureAd.tenantId}/oauth2/v2.0/authorize`,
      end_session_endpoint: `https://login.microsoftonline.com/${env.azureAd.tenantId}/oauth2/v2.0/logout`,
    },
    client_id: env.azureAd.clientId,
    redirect_uri: `${globalThis.location.origin}/login`,
    scope: `openid profile email api://${env.azureAd.clientId}/user_impersonation`,
    // resource: `${env.azureAd.clientId}`,
    onSigninCallback,
    userStore,
  };

  return <OIDCContextProvider {...oidcConfig}>{children}</OIDCContextProvider>;
}

export default AuthProvider;

